__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "sbx-operations-servicejobmanagement-reassign-ui";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@sbx/sbx-deimos-reactui-common", "6.0.3", () => (__webpack_require__.e(489).then(() => (() => (__webpack_require__(98489))))));
			register("@sbx/sbx-ui-components", "9.7.33", () => (__webpack_require__.e(602).then(() => (() => (__webpack_require__(52602))))));
			register("classnames", "2.5.1", () => (__webpack_require__.e(73).then(() => (() => (__webpack_require__(87073))))));
			register("indexof", "0.0.3", () => (__webpack_require__.e(875).then(() => (() => (__webpack_require__(89875))))));
			register("lodash", "4.17.21", () => (__webpack_require__.e(820).then(() => (() => (__webpack_require__(66820))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(198).then(() => (() => (__webpack_require__(52198))))));
			register("react-big-calendar", "1.13.1", () => (__webpack_require__.e(206).then(() => (() => (__webpack_require__(90206))))));
			register("react-cookie", "4.1.1", () => (__webpack_require__.e(653).then(() => (() => (__webpack_require__(14653))))));
			register("react-dom", "18.3.1", () => (__webpack_require__.e(834).then(() => (() => (__webpack_require__(19834))))));
			register("react-redux", "7.2.9", () => (__webpack_require__.e(244).then(() => (() => (__webpack_require__(6244))))));
			register("react-redux", "8.1.3", () => (__webpack_require__.e(559).then(() => (() => (__webpack_require__(71559))))));
			register("react-router-dom", "5.3.4", () => (__webpack_require__.e(941).then(() => (() => (__webpack_require__(95941))))));
			register("react-router-dom", "6.25.1", () => (__webpack_require__.e(101).then(() => (() => (__webpack_require__(58863))))));
			register("react-tooltip", "5.27.1", () => (__webpack_require__.e(663).then(() => (() => (__webpack_require__(73663))))));
			register("react", "18.3.1", () => (__webpack_require__.e(471).then(() => (() => (__webpack_require__(39471))))));
			register("redux-saga", "1.3.0", () => (__webpack_require__.e(930).then(() => (() => (__webpack_require__(53930))))));
			register("redux-thunk", "2.4.2", () => (__webpack_require__.e(376).then(() => (() => (__webpack_require__(66376))))));
			register("redux", "4.2.1", () => (__webpack_require__.e(601).then(() => (() => (__webpack_require__(87601))))));
			register("styled-components", "5.3.11", () => (__webpack_require__.e(418).then(() => (() => (__webpack_require__(80418))))));
			register("styled-components", "5.3.3", () => (__webpack_require__.e(469).then(() => (() => (__webpack_require__(63469))))));
			register("styled-components", "6.1.12", () => (__webpack_require__.e(770).then(() => (() => (__webpack_require__(75770))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(529).then(() => (() => (__webpack_require__(50529))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};